import { render, staticRenderFns } from "./PartnerFull.vue?vue&type=template&id=685fcf80"
import script from "./PartnerFull.vue?vue&type=script&lang=js"
export * from "./PartnerFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports